<template>
  <div class="reports">
    <transition name="component-fade">
      <v-container fluid :grid-list-sm="true" secondary>
        <v-layout>
          <v-flex xs12>
            <v-card style="margin: 30px; min-height: 84vh;">
              <!-- <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear> -->
              <v-card-actions  >
              <v-card-actions class="dropdowns-container" >
                <div class="admin-access-section" v-if="hasAdminAccess" >
                  <employee-status-dropdown 
                    :employees="employees" 
                    v-model="selectedEmployee" 
                    :disabled="isSelectLoading || !logs.length"
                    :loading="isSelectLoading"
                    @input="selectEmployee"
                  ></employee-status-dropdown>
                </div>
                <div v-if="this.isAdmin" style="width:271px">
                </div>
                <div class="search-group" >
                <div class="searchable-1">
                <SearchableDropdown
                  :items="months"
                  v-model="currentMonth"
                  @select="selectMonthYear"
                  :disabled="isSelectLoading || !logs.length"
                  :loading="isSelectLoading"
                  label-key="name"
                  :placeholder="currentMonth || 'Select Month'"
                    
                />

                </div>
                <div>
                <SearchableDropdown
                  :items="years"
                  v-model="currentYear"
                  @select="selectMonthYear"
                  :disabled="isSelectLoading || !logs.length"
                  :loading="isSelectLoading"
                  label-key="name"
                  :placeholder="currentYear ? Number(currentYear) : 'Select Year'"
                    
                />
                </div>
                </div>
                <button class="pdf-button" :disabled="isSelectLoading || !logs.length" @click="exportPDF">Export as PDF</button>
              </v-card-actions>
              </v-card-actions>
              <v-card-actions class="select-container" style="margin-top:-25px; margin: 0px 15px;">
                <div class="text-xs-center" v-for="item in description" :key="item.for + item.color">
                  <v-chip class="chips chips-container" :style="{color: item.color}" style="background-color: #435851;">
                    <v-icon class="text--darken-2" style="font-size: 22px;">{{item.icon}}</v-icon>
                    <span style="color: white; display: inline-block; text-align: left; margin-left:8px">{{item.for}}</span>
                  </v-chip>
                </div>
                <div class="edit-request-count" style="padding: 10px; font-weight: bold;">
                  <div class="edit-request-inner">
                    Pending Edit Requests for {{ currentMonth }} {{ currentYear }} : <span style="color:#5EC1A5">{{ pendingEditRequestCount }}</span>
                  </div>
                </div> 
              </v-card-actions>
              <hr/>
              <div v-if="isSelectLoading || !logs.length" class="loader-overlay">
                <div class="loader-container">
                  <DoubleLoader class="loader" />
                </div>
              </div>
              <div v-else>
                <MonthlyStats
                  :logs="logs"
                  :working-days="workingDays"
                  :working-hours="workingHours"
                  :month="currentMonth"
                  :year="String(currentYear)"
                  :average-hours="averageHours"
                  :average-minutes="averageMinutes"
                  :holidays="holidays"  
                />
          
                <v-divider></v-divider>
            
                <v-container fluid :[(`grid-list-${size}`)]="true">
                  <v-layout row wrap style="padding: 10px; display:flex; flex-wrap:wrap;">
                    <v-flex class="log-flex" v-for="(day, index) in days" :key="index" style="flex: 1 0 240px; max-width: 300px;">
                      <v-expansion-panel popout focusable elevation="1" style="transition: none;">
                      <v-badge v-if="logs[index] && logs[index].editRequest" color="#5EC1A5" overlap
                        style="position: absolute; top: 5px; right: -10px;">
                          <template v-slot:badge>
                          <v-icon @click="openEditRequestModal(logs[index])"
                            style="cursor: pointer; color:white; font-size: 20px;">mdi-bell-alert</v-icon>
                          </template>
                          <span></span>
                        </v-badge>
                      <div style="position:  absolute; z-index:0; gap: 6px; top: 70px; justify-content: end; right: 55px; width: 50px; display: flex;">                          
                          <div
                            v-if="logs && logs[index] && manualHoursActivities.some(activity => activity.Key === logs[index].key)"
                            @click="openHistoryModal(manualHoursActivities.filter(activity => activity.Key === logs[index].key))"
                            style="cursor: pointer; color: white; font-size: 10px; min-width:18px; height:18px; border-radius: 50%; display:flex; background-color: #5EC1A5; text-align: center; align-items: center; justify-content: center;"
                          >
                            <span style="font-size: 12px; line-height: 1;">M</span>
                          </div>
                          <div v-if="isHoliday(index + 1) && hasAdminAccess" :title="isHoliday(index + 1)"
                            style="cursor: pointer; color: white; font-size: 10px; min-width:18px; height:18px; border-radius: 50%; display:flex; background-color: white; color: orange; text-align: center; align-items: center; justify-content: center;">
                            <span style="font-size: 12px; line-height: 1;">H</span>
                          </div>
                          <v-icon 
                            v-if="shouldHighlight(logs[index]).highlight"
                            @click="openMapPopup(index)" icon :index="index" 
                          style="font-size: 22px; margin-top:-1.9px;  display:flex; align-items:center; justify-content:center; opacity:0.9;"  
                            :color="shouldHighlight(logs[index]).isExpertizo ? 'rgba(211,47,47,0.9)' : 'blue'">
                            mdi-map-marker 
                          </v-icon>
                                            
                          <v-icon
                            v-if="checkLateScreenshot(logs[index])"
                            color="orange"
                            overlap
                            style="font-size: 22px; margin-top:-2px; display:flex; align-items:center; justify-content:center;"
                            title="No screenshot taken within 20 minutes."
                          >
                            mdi-clock-alert
                          </v-icon>

                        </div>
                 
                    <v-expansion-panel-content v-model="expandedPanels[index]"
                        :class="{ 'grey' : day.indexOf('*') + 1 }" :style="isHoliday(index + 1) ? 'background-color: 	#ffd7b5' : ''" hide-actions>
                      <div slot="header"
                        style="padding: 10px 0; display: flex; justify-content: space-between; align-items: center;">
                            <div style="">
                              <p style="margin: 0px; margin-top: 15px">{{ day.slice(0, day.indexOf('*')) }}</p>
                              <p style="margin: 0px; margin-top: 10px;">{{ index + 1 }}</p>
                            </div>
                        <div
                          style="position: relative; display: flex; margin-top: 8px; align-items: center; flex-direction: column-reverse; gap:12px">
                              <v-icon v-if="logs[index]"
                          :class="{ 'red--text': logs[index].late.hours || logs[index].late.minutes, 
                          'lightgreen--text': !logs[index].late.hours && !logs[index].late.minutes }"
                                class="text--darken-2 late" style="font-size: 22px;">
                                mdi-clock-outline
                              </v-icon>
<span class="edit-icon" style="margin-top: -4px"  v-if="$store.state.auth.user && hasAdminAccess && !logs[index]">
                          <v-icon style="color:green; font-size: 16px"
                          v-if="$store.state.auth.user && hasAdminAccess && !logs[index]"
                          @click.stop="editLog(index+1)">mdi-pencil</v-icon>
                              </span>
                              <div v-if="isHoliday(index + 1) && !hasAdminAccess" :title="isHoliday(index + 1)" style="cursor: pointer; color: white; font-size: 10px; min-width:18px; height:18px; border-radius: 50%; display:flex; background-color: white; color: orange; text-align: center; align-items: center; justify-content: center; margin-right: .5px;">
                            <span style="font-size: 12px; line-height: 1;">H</span>
                          </div>
                          <v-icon class="custom-angle-icon" style="font-size: 25px;"
                            :title="'Expanded: ' + expandedPanels[index]">
                                {{ expandedPanels[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                              </v-icon>
                            </div>
                          </div>
                      <v-card v-if="logs[index]" class="blue-grey darken-2 white--text card-info"
                        style="margin-top: 20px; height: auto; position: relative; ">
                            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                          <v-icon class="red--text text--darken-2"
                            style="font-size: 20px; margin-right: 8px;">mdi-clock-outline</v-icon>
                              <span v-if="logs[index].late.hours != 0 || logs[index].late.minutes != 0">
                                <span v-if="logs[index].late.hours != 0">{{ logs[index].late.hours }} hours and</span>
                                <span>{{ logs[index].late.minutes }} minutes</span>
                              </span>
                              <span v-else>Not Late!</span>
                            </div>
                            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                          <v-icon class="blue--text text--darken-2"
                            style="font-size: 20px; margin-right: 8px;">mdi-login</v-icon>
                              <span>
                            <span
                            style="display: flex; align-items: center; flex-wrap: wrap"
                              v-if="
                                logs[index] && 
                                logs[index].editRequest && 
                                logs[index].editRequest.timeIn !== logs[index].timeIn
                              ">
                                  <span :style="{ textDecoration: 'line-through' }">{{ logs[index].timeIn }}</span> 
                                <span style=" margin-left: 8px;"> {{ logs[index].editRequest.timeIn }}</span>
                                <span  style="margin-left:5px; font-size: 9px; color:#ffa500"></span>
                                  <span class="custom-tooltip-wrapper" style="position: relative; display: inline-block; margin: 5px 0px; z-index: 10000;"
                                    v-if="logs[index].originalTimeIn !== logs[index].editRequest.timeIn"
                                    >
                                    <v-icon
                                      small
                                      color="#5EC1A5"
                                      style="margin-left: 4px; cursor: pointer; z-index: 10000;"
                                      @mouseover="logMouseover"
                                      @mouseleave="logMouseleave"
                                    >mdi-information</v-icon>
                                    <span class="custom-tooltip" >
                                     Reason: {{ logs[index].editRequest.reason || 'No reason provided' }}
                                  </span>
                                  </span>
                                </span>
                            <span v-else>
                              {{ logs[index].timeIn }}
                            </span>
                              </span>
                            </div>
                            <div v-if="logs[index].break && logs[index].break.breakStart" style="display: flex; align-items: center; margin-bottom: 10px;">
                              <v-icon class="orange--text text--darken-1"
                                style="font-size: 20px; margin-right: 8px;">mdi-food</v-icon>
                              <span>
                                <span>
                                  {{ formatTime(logs[index].break.breakStart) }}
                                </span>
                              </span>
                            </div>
                            <div v-if="logs[index].break && logs[index].break.breakEnd" style="display: flex; align-items: center; margin-bottom: 10px;">
                              <v-icon class="green--text text--darken-2"
                                style="font-size: 20px; margin-right: 8px;">mdi-food-off</v-icon>
                              <span>
                                <span>
                                  {{ formatTime(logs[index].break.breakEnd) }}
                                </span>
                              </span>
                            </div>
                            <div v-if="logs[index].break && logs[index].break.breakExceededMs" style="display: flex; align-items: center; margin-bottom: 10px;">
                              <v-icon class="red--text text--darken-2"
                                style="font-size: 20px; margin-right: 8px;">mdi-clock-alert</v-icon>
                              <span>
                                <span>
                                  {{ formatDuration(logs[index].break.breakExceededMs) }}
                                </span>
                              </span>
                            </div>
                            <div class="time-status-container" style="margin-bottom: 10px;">
                          <!-- <div v-if="logs[index].timeOut" -->
                        <div v-if="checkTimeoutResult(index, userOnline(logs[index]))" 
                        style="display: flex; align-items: center; margin-bottom: 10px;">
                          <v-icon class="yellow--text text--darken-2"
                           style="font-size: 20px; margin-right: 8px;">mdi-logout</v-icon>
                            <!-- {{ checkTimeoutResult(index) }} -->
                          <span>
                            <span 
                             style="display: flex; align-items: center; flex-wrap: wrap"
                            v-if="logs[index].editRequest && logs[index].editRequest.timeOut !== logs[index].timeOut">
                              <span :style="{ textDecoration: 'line-through' }">{{ checkTimeoutResult(index)}}</span>
                              <span style=" margin-left: 8px;"> {{ logs[index].editRequest.timeOut }}</span>
                              <span style="margin-left:5px; font-size: 9px; color:#ffa500"></span>
                              <span
                                v-if="logs[index].editRequest && logs[index].editRequest.originalTimeIn === logs[index].editRequest.timeIn && logs[index].editRequest.originalTimeOut !== logs[index].editRequest.timeOut"
                                @click="logTooltipCondition(index)"
                                class="custom-tooltip-wrapper"
                                style="position: relative; display: inline-block; margin: 5px; z-index: 10000;"
                              >
                                <v-icon
                                  small
                                  color="#5EC1A5"
                                  style="margin-left: 3px; cursor: pointer; z-index: 10000;"
                                  @mouseover="logMouseover"
                                  @mouseleave="logMouseleave"
                                >mdi-information</v-icon>
                                <span class="custom-tooltip" >
                                  Reason: {{ logs[index].editRequest.reason || 'No reason provided' }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              {{ logs[index].timeOut }}
                            </span>
                          </span>
                        </div>
                          <!-- <div v-if="logs[index].userStatus === 'User Online'" class="user-status" -->
                          <div v-if="userOnline(logs[index])" class="user-status"
                            style="display: flex; align-items: center;">
                                <v-icon class="lightgreen--text" style="font-size: 20px; margin-right: 8px;">mdi-account-check</v-icon>
                                {{ logs[index].userStatus }}
                              </div>
                            </div>
                            <div style="display: flex; align-items: center; margin-bottom: 50px;">
                          <v-icon class="lightgreen--text text--darken-2"
                            style="font-size: 20px; margin-right: 8px;">mdi-check-circle-outline</v-icon>
                              <span>
                            <span v-if="logs[index].completed.hours != 0">{{ logs[index].completed.hours }} hours
                              and</span>
                                <span>{{ logs[index].completed.minutes }} minutes</span>
                              </span>
                            </div>
                            <div class="card-bottom">
                              <v-btn icon style="" primary dark @click.stop="editLog(logs[index])">
                                <v-icon style="margin: 3px; font-size: 20px;">mdi-pencil</v-icon>
                              </v-btn>
                        <v-btn icon style="" primary dark
                          :index="index" @click="details(index)">
                                <v-icon style="margin: 3px; font-size: 20px;">mdi-information</v-icon>
                              </v-btn>
                            </div>
                          </v-card>
                        </v-expansion-panel-content>
                    <v-progress-linear v-if="logs[index]  && Number.isFinite(logs[index].completedPercent) && logs[index].completedPercent >= 88"
                      :value="logs[index].completedPercent" height="5" success color="green" class="progress-bar"
                      @update:value="console.debug('Success bar index:', index, 'completedPercent:', logs[index].completedPercent)"></v-progress-linear>
                    <v-progress-linear v-if="!logs[index] || !Number.isFinite(logs[index].completedPercent)"
                      height="5" secondary color="grey" class="progress-bar"
                      @update:value="console.debug('Secondary bar index:', index, 'completedPercent:', 
                      logs[index] ? logs[index].completedPercent : 'null')"></v-progress-linear>
                    <v-progress-linear
                      v-if="logs[index] && Number.isFinite(logs[index].completedPercent) && logs[index].completedPercent < 88"
                      :value="logs[index].completedPercent" height="5" error color="red" class="progress-bar"
                      @update:value="console.debug('Error bar index:', index, 'completedPercent:', logs[index].completedPercent)"></v-progress-linear>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
                <v-dialog v-model="previewDetails" width="800px" transition="dialog-bottom-transition" :overlay="false"
                  id="preview-dialog" >
                <v-card v-if="currentObj">
                  <v-card-title>
                    <span style="margin-left: 10px;" class="headline">
                        <span v-if="currentImgObj">Screenshot at {{moment(currentImgObj.timestamp).format('h:mm:ss a')}}
                          on</span>
                      {{ currentMonth}} {{currentObj.day}}, {{ currentYear}}
                    </span>
                      <div style="width: 85%; text-align: right" v-if="!currentImgObj"
                        :style="{ color: currentObj.completedPercent >= 88 ? '#02e009' : currentObj.completedPercent >= 50 ? 'yellow' : 'red' }">
                      <div>Time Completed</div>
                        <v-progress-circular id="dialog3" :size="100" :width="15" :rotate="-90"
                          :value="currentObj.completedPercent">{{ parseInt(currentObj.completedPercent) }}%
                        </v-progress-circular>
                    </div>
                  </v-card-title>
                    <v-card-text >
                        <v-layout wrap >
                      <v-flex>
                            <div style="margin-top: 10px ; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                              <span v-if="!currentImgObj" class="text-xs-center"
                               v-for="(item, index) in currentObj.screenshots" @click="previewImage(index)"
                                style="margin: 10px; display: inline-block; cursor: pointer" :key="index">
                            <img :src="item.url" alt style="width: 215px; height: 120px" >
                            <br>
                            <p>{{moment(item.timestamp).format('h:mm:ss a')}}</p>
                          </span>
                          <img v-if="currentImgObj" :src="currentImgObj.url" style="width: 100%; height: 100%">
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="action-buttons" style="background-color: transparent;">
                    <!-- <v-spacer></v-spacer> -->
                    <div v-if="currentImgObj" >
                      <v-btn class="next-previous-btn" text @click="prevScreenshot" :disabled="currentScreenshotIndex <= 0">
                        <v-icon left>mdi-arrow-left</v-icon> Previous
                      </v-btn>
                      <v-btn class="next-previous-btn" text @click="nextScreenshot" :disabled="currentScreenshotIndex >= currentObj.screenshots.length - 1">
                        Next <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                    <div>
                    <v-btn v-show="currentImgObj" class="next-previous-btn" text
                        @click="currentImgObj = null">Back</v-btn>
                    <v-btn class="next-previous-btn" text @click="previewDetails = false">Close</v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <div style="position: relative; z-index:99;">
                <ReuseableModal
                  :modelValue="mapPopup"
                  @update:modelValue="mapPopup = $event"
                  title="User Location"
                  submitButtonText="Close"
                  :xlarge="true"
                  :hideCancelButton="true"
                  @submit="mapPopup = false"
                >
                  <template #default>
                    <div v-if="currentCoordinates">
                      <!-- Case: User logs (timeIn / timeOut) -->
                      <div v-if="currentCoordinates.timeIn || currentCoordinates.timeOut">
                        <div
                          v-if="currentCoordinates.timeIn"
                          style="width: 100%; height: 200px;"
                          id="mapIn"
                        ></div>
                        <div
                          v-if="currentCoordinates.timeOut"
                          style="width: 100%; height: 200px; margin-top: 10px;"
                          id="mapOut"
                        ></div>
                      </div>

                      <!-- Case: Activity log (direct latitude/longitude) -->
                      <div
                        v-else-if="currentCoordinates.latitude && currentCoordinates.longitude"
                        style="width: 100%; height: 200px;"
                        id="mapActivity"
                      ></div>

                      <!-- Fallback -->
                      <div v-else>
                        <p>No location data available.</p>
                      </div>
                    </div>
                  </template>
                </ReuseableModal>
              </div>
              <ReuseableModal
                :modelValue="isEditRequestModalOpen"
                :showSubmitButton="false"
                @update:modelValue="isEditRequestModalOpen = $event"
                @submit="closemodal"
                title="Review Time Edit Request"
                submitButtonText="Close"
                :hideCancelButton="true"
              >
                <template v-slot:default>
                  <div v-if="selectedEditRequest">
                    <!-- Time In -->
                    <p style="margin:10px">
                      <span
                        v-if="
                          selectedEditRequest.editRequest &&
                          selectedEditRequest.originalTimeIn !== selectedEditRequest.editRequest.timeIn
                        " style="display: flex; align-items: center; flex-wrap: wrap; max-width: 400px;
                        "> 
                        <strong>Time In:</strong>
                        <span style="text-decoration: line-through; margin-right: 8px; margin-left:5px">{{ selectedEditRequest.originalTimeIn }}</span> 
                        <span style="margin-left: 8px;">{{ selectedEditRequest.editRequest.timeIn }}</span>
                        <span style="margin-left: 5px; font-size: 10px; color: #5EC1A5;">(Pending)</span>
                          <v-tooltip top content-class="tooltip-fix" v-if="selectedEditRequest.originalTimeIn !== selectedEditRequest.editRequest.timeIn">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small color="#5EC1A5" style="margin-left: 3px; cursor: pointer;">mdi-information</v-icon>
                            </template>
                            <span style="display:inline-block; max-width:300px; text-align:center; background:#000000; padding:5px 8px; color:#ffffff; border-radius:4px; word-wrap:break-word;">
                              Reason: {{ selectedEditRequest.editRequest.reason }}
                            </span>
                          </v-tooltip>
                      </span>
                    </p>
                    <!-- Time Out -->
                    <p style="margin:10px">
                      <span
                        v-if="
                          selectedEditRequest.editRequest &&
                          selectedEditRequest.originalTimeOut !== selectedEditRequest.editRequest.timeOut
                        " style="display: flex; align-items: center; flex-wrap: wrap; max-width: 400px;
                        ">
                        <strong>Time Out:</strong>
                        <span style="text-decoration: line-through; margin-left: 5px; margin-left: 5px;">{{ selectedEditRequest.originalTimeOut }}
                        </span> <span style="margin-left: 8px;">{{ selectedEditRequest.editRequest.timeOut }}</span>  
                        <span style="margin-left: 5px; font-size: 10px; color: #5EC1A5;">(Pending)</span>
                          <v-tooltip top content-class="tooltip-fix" v-if="selectedEditRequest.originalTimeIn === selectedEditRequest.editRequest.timeIn && selectedEditRequest.originalTimeOut !== selectedEditRequest.editRequest.timeOut">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small color="#5EC1A5" style="margin-left: 3px; cursor: pointer;">mdi-information</v-icon>
                            </template>
                            <span style="display:inline-block; max-width:300px; text-align:center; background:#000000; color:#ffffff; padding:5px 8px; border-radius:4px; word-wrap:break-word;">
                              Reason: {{ selectedEditRequest.editRequest.reason }}
                            </span>
                          </v-tooltip>
                      </span>
                    </p>
                  </div>

                  <div>
                    <v-btn  v-if="canPerformRequestAction(selectedEditRequest.editRequest, $store.state.auth.user, 'approve').allowed" color="#5EC1A5" style="color:white; outline:none; border-radius:6px" @click="approveEditRequest">
                      <v-icon left>mdi-check</v-icon> Approve
                    </v-btn>
                    <v-btn v-if="canPerformRequestAction(selectedEditRequest.editRequest, $store.state.auth.user, 'reject').allowed" color="red" style="color:white; outline:none; border-radius:6px" @click="rejectEditRequest">
                      <v-icon left>mdi-close</v-icon> Reject
                    </v-btn>
                  </div>
                </template>
              </ReuseableModal>
              <ReuseableModal
                :modelValue="isHistoryModalOpen"
                @update:modelValue="isHistoryModalOpen = $event"
                title="Activity History"
                submitButtonText="Close"
                :xlarge="true"
                :hideCancelButton="true"
                @submit="closeHistoryModal"
              >
                <template #default>
                  <HistoryActivityTable :activities="manualHoursActivity" :columns="columns" @open-map="openMapPopup" />
                </template>
              </ReuseableModal>
              <v-card v-if="!loading && !logs.length" class="text-xs-center">
                <v-card-text>
                  <h3>No logs available for this month.</h3>
                </v-card-text>
              </v-card>
            </v-card>
          </v-flex>
        </v-layout>
        <ReuseableModal :modelValue="isEditModalOpen" @update:modelValue="isEditModalOpen = $event"
          title="Update the time" submitButtonText="Submit" :loading="loading.editRequest" @submit="submitAction">
          <template #default>
            <form @submit.prevent="submitAction">
              <div class="form-group time-dropdown-container">
                <label for="lateTime">Time In</label>
                <div class="time-columns">
                  <LateTimeDropdown :data="hours" :selected="selectedDay.timeInHour" @change="updateTimeInHour" />
                  <LateTimeDropdown :data="minutes" :selected="selectedDay.timeInMinute" @change="updateTimeInMinute" />
                      <LateTimeDropdown :data="meridians" :selected="selectedDay.timeInMeridian"
                        @change="updateTimeInMeridian" />
                </div>
              </div>

              <div class="form-group time-dropdown-container">
                <label for="lateTime">Time Out</label>
                <div class="time-columns">
                  <LateTimeDropdown :data="hours" :selected="selectedDay.timeOutHour" @change="updateTimeOutHour" />
                      <LateTimeDropdown :data="minutes" :selected="selectedDay.timeOutMinute"
                        @change="updateTimeOutMinute" />
                      <LateTimeDropdown :data="meridians" :selected="selectedDay.timeOutMeridian"
                        @change="updateTimeOutMeridian" />
                </div>
              </div>
              <div style="margin-top: 10px;">
                <label for="reason">Reason for Edit Request <span style="color: red;">*</span></label>
                <textarea
                  id="reason"
                  v-model="reason"
                  required
                  placeholder="Enter reason for edit request"
                  rows="3"
                  style="width: 100%;"
                  maxlength="400"
                ></textarea>
                <!-- ✅ Character count -->
                <div style="text-align: right; font-size: 12px; color: gray; margin-top: 4px;">
                  {{ reason.length }} / 400
                </div>
              </div>
            </form>
          </template>
    </ReuseableModal>

      </v-container>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase/app";
import moment from "moment";
import _ from "underscore";
import jsPDF from "jspdf";
import "firebase/database";
import '@mdi/font/css/materialdesignicons.css'
import firebaseDB from "../../../assets/config/firebase";
import MonthlyStats from "../../UIComponents/MonthlyStatus.vue";
import ReuseableModal from "../../UIComponents/ReuseableModal.vue"
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import swal from "sweetalert";
import LateTimeDropdown from "../../UIComponents/LateTimeDropdown.vue";
import DoubleLoader from "../../UIComponents/loaders/DoubleLoader.vue";
import constants from "../../../assets/config/constants";
import { logAdminActivity } from "../../../utils/adminLogs";
import { isExpertizoLocation } from "../../../utils/expertizoLocation.js";
import { canPerformRequestAction } from "../../../utils";
import HistoryActivityTable from "../../UIComponents/HistoryActivityTable.vue";
import { settings } from "../../../utils/genralSpecificSettings";
import EmployeeStatusDropdown from "../../UIComponents/EmployeeStatusDropdown.vue";
import SearchableDropdown from "../../UIComponents/Dropdowns/SearchableDropdown.vue";
import { handleActivityNotification } from "../../../services/notificationService.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "Reports",
  components: {
    MonthlyStats,
    ReuseableModal,
    LateTimeDropdown,
    DoubleLoader,
    HistoryActivityTable,
    EmployeeStatusDropdown,
    SearchableDropdown,
  },
  async mounted() {
    this.getAllHolidays;
    await this.$store.dispatch('fetchConstantsRealTime');
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  created:async function() {
    const company = this.$store.state.auth.company;
    try {
      if (!firebase.apps.length) {
        await firebaseDB.configureFirebase(company.firebase);
      }
    } catch (e) {
      console.error("Firebase initialization error:", e.message);
    }
    let store = this.$store;
    let user = this.$store.state.auth.user;
    store.commit("loadingStarts");
    // const constants = this.$store.state.auth.constants || {};
    if (user) {
      this.init(user);
    } else {
      this.$store.watch(this.$store.getters.getUser, user => {
        this.init(user);
      });
    }
    try {
      await this.getSettingData();
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  },
  data: () => ({
    hours: Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0")),
    minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0")),
    meridians: ["AM", "PM"],
    isEditModalOpen: false,
    isEditRequestModalOpen: false,
    isHistoryModalOpen: false,
    isSelectLoading: false,
    selectedDay: {
      timeInHour: "09",
      timeInMinute: "00",
      timeInMeridian: "AM",
      timeOutHour: "05",
      timeOutMinute: "00",
      timeOutMeridian: "PM"
    },
    loading: {
        editRequest: false,
    },
    selectedEditRequest: null,
    reason: "",
    description: [
      { icon: "mdi-clock-outline", color: "red", for: "Late" },
      { icon: "mdi-login", color: "blue", for: "Time In" },
      { icon: "mdi-food", color: "orange", for: "Break Start" },
      { icon: "mdi-food-off", color: "#77C97B", for: "Break End" },
      { icon: "mdi-clock-alert", color: "#D74343", for: "Break Exceed" },
      { icon: "mdi-logout", color: "yellow", for: "Time Out" },
      { icon: "mdi-check-circle-outline", color: "#4eee19", for: "Completed" }
    ],
    expandedPanels: [],
    employees: [],
    moment: moment,
    selectedEmployee: "",
    size: "xl",
    currentMonth: "",
    currentYear: "",
    currentObj: null,
    currentImgObj: null,
    currentScreenshotIndex: 0,
    previewDetails: false,
    hasAdminAccess : false,
    isAdmin: false,
    days: 0,
    workingDays: [],
    holidays: [],
    workingHours: 0,
    years: [],
    months: [
      { name: "January" },
      { name: "February" },
      { name: "March" },
      { name: "April" },
      { name: "May" },
      { name: "June" },
      { name: "July" },
      { name: "August" },
      { name: "September" },
      { name: "October" },
      { name: "November" },
      { name: "December" }
    ],
    logs: [],
    mapPopup: false,
    currentCoordinates: null,
    manualHoursActivities: [],
    manualHoursActivity: [],
    columns: [
      { label: "Activity On", key: "activityOnUserName", width: "200px" },
      { label: "Activity By", key: "activityByUserName", width: "200px" },
      { label: "Action", key: "action" },
      { label: "Time In", key: "timeInChange",width: "200px", },
      { label: "Time Out  ", key: "timeOutChange",width: "200px", },
      { label: "Reason", key: "reason",width: "250px",truncate: true, length: 30 },
      { label: "Timestamp", key: "timestamp", width: "230px", truncate: true, length: 20 },
      { label: "OS", key: "osName" },
      { label: "Browser", key: "browserName" },
      { label: "Map", key: "map", width: "70px" },
    ],
  }),
  watch: {
    user(newVal) {
      if (newVal) {
        this.init(newVal);
      }
    },
    mapPopup(val) {
      if (!val) {
        if (L.DomUtil.get("mapIn") != null) {
          L.DomUtil.get("mapIn")._leaflet_id = null;
        }
        if (L.DomUtil.get("mapOut") != null) {
          L.DomUtil.get("mapOut")._leaflet_id = null;
        }
        this.currentCoordinates = null;
      }
    },
    currentImgObj(val) {
      if (val && this.currentObj && this.currentObj.screenshots) {
        this.currentScreenshotIndex = this.currentObj.screenshots.findIndex(s => s.url === val.url);
      }
    }
  },
  computed: {
    pendingEditRequestCount() {
      return this.logs.filter(log => log && log.editRequest).length;
    },
    averageHours() {
      const stats = this.calculateMonthlyStats();
      return stats.averageHours;
    },
    averageMinutes() {
      const stats = this.calculateMonthlyStats();
      return stats.averageMinutes;
    },
  },
  methods: {
    handleKeyboard(e) {
      if (this.previewDetails && this.currentImgObj) {
        if (e.key === 'ArrowLeft') {
          this.prevScreenshot();
        } else if (e.key === 'ArrowRight') {
          this.nextScreenshot();
        }
      }
    },
    prevScreenshot() {
      if (this.currentScreenshotIndex > 0) {
        this.currentScreenshotIndex--;
        this.currentImgObj = this.currentObj.screenshots[this.currentScreenshotIndex];
      }
    },
    nextScreenshot() {
      if (this.currentScreenshotIndex < this.currentObj.screenshots.length - 1) {
        this.currentScreenshotIndex++;
        this.currentImgObj = this.currentObj.screenshots[this.currentScreenshotIndex];
      }
    },
    isHoliday(dayNumber) {
      const selectedYear = this.currentYear;
      const selectedMonth = new Date(`${this.currentMonth} 1, ${selectedYear}`).getMonth();

      const selectedEmployeeObj = this.employees.find(
        emp => emp.uid === this.selectedEmployee
      );

      const baseShift =
        this.isAdmin && selectedEmployeeObj
          ? selectedEmployeeObj.shift
          : this.$store.state.auth.user.shift;

      const userShift = (baseShift || "Morning").toLowerCase();

      let workingDays = [];
      if (
        selectedEmployeeObj &&
        Array.isArray(selectedEmployeeObj.workingDays) &&
        selectedEmployeeObj.workingDays.length
      ) {
        workingDays = selectedEmployeeObj.workingDays.map(d => d.toLowerCase());
      } else {
        workingDays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      }

      const currentDate = new Date(selectedYear, selectedMonth, dayNumber);
      currentDate.setHours(0, 0, 0, 0);

      const dayName = currentDate
        .toLocaleDateString("en-US", { weekday: "long" })
        .toLowerCase();

      if (!workingDays.includes(dayName)) return "";

      const matches = this.holidays.filter(h => {
        const baseDate = new Date(h.dates);
        baseDate.setHours(0, 0, 0, 0);

        const isRecurring = !!h.isRecurring;
        const daysCount = h.numberOfDays || 1;

        const startDate = new Date(
          isRecurring ? selectedYear : baseDate.getFullYear(),
          baseDate.getMonth(),
          baseDate.getDate()
        );
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + daysCount - 1);

        if (currentDate < startDate || currentDate > endDate) return false;

        if (currentDate.getMonth() !== selectedMonth) return false;

        const hShift = (h.shift || "").toLowerCase();
        if (hShift === "general") return true;

        return hShift === userShift;
      });

      if (!matches.length) return "";

      return matches.map(h => h.name).join(", ");
    },
    logMouseover() {
      console.log('Hovering timeOut icon');
    },
    logMouseleave() {
      console.log('Mouseleave timeOut icon');
    },
    logEditRequest(index) {
      console.log('editRequest:', this.logs[index].editRequest);
    },
    logTooltipCondition(index) {
      console.log('editRequest:', this.logs[index].editRequest);
      console.log('Tooltip v-if condition:', this.logs[index].originalTimeOut !== this.logs[index].editRequest.timeOut);
      console.log('originalTimeOut:', this.logs[index].originalTimeOut);
      console.log('editRequest.timeOut:', this.logs[index].editRequest.timeOut);
    },
    async getSettingData() {
      try {
        const response = await settings(this.selectedEmployee, this.$store.state.auth.constants);
        if (response) {
          this.days = response.days || 0;
          this.workingDays = response.days;
          this.workingHours = response.totalHours;
        } else {
          console.warn("No settings data found for the selected employee.");
        }
      } catch (error) {
        console.error("Error fetching settings data:", error);
      }
    },

    canPerformRequestAction,
    updateTimeInHour(value) {
      this.selectedDay.timeInHour = value;
    },
    updateTimeInMinute(value) {
      this.selectedDay.timeInMinute = value;
    },
    updateTimeInMeridian(value) {
      this.selectedDay.timeInMeridian = value;
    },
    updateTimeOutHour(value) {
      this.selectedDay.timeOutHour = value;
    },
    updateTimeOutMinute(value) {
      this.selectedDay.timeOutMinute = value;
    },
    updateTimeOutMeridian(value) {
      this.selectedDay.timeOutMeridian = value;
    },
    calculateLate: async function (timeInRaw) {
      let lateHours = 11;
      let lateMinutes = 0;

      const timeInMoment = moment(timeInRaw);

      try {
        const response = await settings(this.selectedEmployee, this.$store.state.auth.constants);
        if (response && response.late && response.late.includes(':')) {
          const [hourStr, minuteStr] = response.late.split(':');
          lateHours = parseInt(hourStr) || 11;
          lateMinutes = parseInt(minuteStr) || 0;
        } else {
          console.warn("fetchedConstants.late missing or wrong format. Using default 11:00 AM");
        }
      } catch (err) {
        console.error("Failed to fetch constants. Using default 11:00 AM", err);
      }

      const allowedLateTime = timeInMoment.clone().hours(lateHours).minutes(lateMinutes).seconds(0).milliseconds(0);
      const diffMinutes = timeInMoment.diff(allowedLateTime, 'minutes');

      return {
        hours: diffMinutes > 0 ? Math.floor(diffMinutes / 60) : 0,
        minutes: diffMinutes > 0 ? diffMinutes % 60 : 0
      };
    },

    editLog(log) {
      if (typeof log === "number") {
        this.selectedDay = {
          timeInHour: "09",
          timeInMinute: "00",
          timeInMeridian: "AM",
          timeOutHour: "05",
          timeOutMinute: "00",
          timeOutMeridian: "PM",
          day: log,
          log: { day: log }
        };
        this.reason = "";
        this.isEditModalOpen = true;
        return;
      }

    // If log is an object (existing log), open modal for editing
      if (log && typeof log === "object") {
        const timeInMoment = moment(log.timeIn, "hh:mm A");
        const timeOutMoment = moment(log.timeOut, "hh:mm A");
        this.selectedDay = {
          timeInHour: timeInMoment.isValid() ? timeInMoment.format("hh") : "09",
          timeInMinute: timeInMoment.isValid() ? timeInMoment.format("mm") : "00",
          timeInMeridian: timeInMoment.isValid() ? timeInMoment.format("A") : "AM",
          timeOutHour: timeOutMoment.isValid() ? timeOutMoment.format("hh") : "05",
          timeOutMinute: timeOutMoment.isValid() ? timeOutMoment.format("mm") : "00",
          timeOutMeridian: timeOutMoment.isValid() ? timeOutMoment.format("A") : "PM",
          log: log,
        };
        this.reason = log.reason || ""; 
        this.isEditModalOpen = true;
        return;
      }
    },
    closemodal() {
      this.isEditRequestModalOpen = false;
    },
    formatTime(time) {
      return moment(time).format("hh:mm A");
    },
    formatDuration(ms) {
      const totalSeconds = Math.floor(ms / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) return `${hours}h ${minutes}m`;
      if (minutes === 0) return `${seconds}s`;
      if (seconds === 0) return `${minutes}m`;
      return `${minutes}m ${seconds}s`;
    },

    async submitAction() {
      const selectedEmployeeObj = this.employees.find(emp => emp.uid === this.selectedEmployee);
      const timeIn = `${this.selectedDay.timeInHour}:${this.selectedDay.timeInMinute} ${this.selectedDay.timeInMeridian}`;
      const timeOut = `${this.selectedDay.timeOutHour}:${this.selectedDay.timeOutMinute} ${this.selectedDay.timeOutMeridian}`;
      const log = this.selectedDay.log;
      const logIndex = this.selectedDay.logIndex;
      if (!this.reason || this.reason.trim() === "") {
        swal("Missing Field", "Please enter a reason for this edit.", "warning");
        return;
      }

      if (
        !this.selectedDay.timeInHour || !this.selectedDay.timeInMinute || !this.selectedDay.timeInMeridian ||
        !this.selectedDay.timeOutHour || !this.selectedDay.timeOutMinute || !this.selectedDay.timeOutMeridian
      ) {
        swal("Missing Fields", "Please fill in all Time In and Time Out fields.", "warning");
        return;
      }

      if (!log || !log.key) {
        try {
          this.loading.editRequest = true
          if (!selectedEmployeeObj) {
            swal("Error", "Please select an employee.", "error");
            return;
          }
        if(!this.$store.state.auth.user.isSuperAdmin == true){
            const { allowed, message } = this.canPerformRequestAction(
              selectedEmployeeObj,
              this.$store.state.auth.user,
              "edit"
            );

            if (!allowed) {
              swal("Error", message, "error");
              return;
            }
          }

          const selectedDayNum = (this.selectedDay.log && this.selectedDay.log.day) || 1;
          if (!this.currentMonth || !this.currentYear) {
            swal("Error", "Please select a valid month and year.", "error");
            return;
          }

          const dateString = `${this.currentMonth} ${selectedDayNum}, ${this.currentYear}`;
          let timeInMoment = moment(`${dateString} ${timeIn}`, "MMMM D, YYYY hh:mm A")
          let timeOutMoment = moment(`${dateString} ${timeOut}`, "MMMM D, YYYY hh:mm A")
          if (!timeInMoment.isValid() || !timeOutMoment.isValid()) {
            swal("Error", "Invalid date or time format.", "error");
            return;
          }
          const isNightShift = selectedEmployeeObj.shift && selectedEmployeeObj.shift.toLowerCase() === "night" || null

          if (isNightShift) {
            const timeInHour = timeInMoment.hours();
            const timeOutHour = timeOutMoment.hours();

            if (timeInHour < 12 && timeOutHour >= 12) {
              swal("Invalid Timing", "12 PM is the cutoff time for night shifts. Please select a valid Time Out.", "error");
              return;
            }
          }

          if (isNightShift && timeOutMoment.valueOf() < timeInMoment.valueOf()) {
            timeOutMoment.add(1, 'day');
          }

          if (timeInMoment.valueOf() > timeOutMoment.valueOf()) {
            swal("Error", "TimeOut must not be earlier than TimeIn.", "error");
            return;
          }

          const obj = {
            name: selectedEmployeeObj.username || '',
            userId: this.selectedEmployee,
            day: selectedDayNum,
            latestScreenshotTime: timeOutMoment.valueOf(),
            timeIn: timeInMoment.valueOf(),
            timeOut: timeOutMoment.valueOf(),
            sessions: [
              {
                timeIn: timeInMoment.valueOf(),
                timeOut: timeOutMoment.valueOf(),
              }
            ],
            screenshots: [],
            late:  await this.calculateLate(timeInMoment),
            createdAt: timeInMoment.valueOf()
          };
          const commonFields = {
            description: `${this.$store.state.auth.user.email} manually entered ${selectedEmployeeObj.email}'s hours for ${this.currentMonth} ${this.selectedDay.day}, ${this.currentYear}. Time In: ${timeIn} and Time Out: ${timeOut}`,
            activityName: `${this.$store.state.auth.user.username} manually entered ${selectedEmployeeObj.username}'s hours for ${this.currentMonth} ${this.selectedDay.day}, ${this.currentYear}. Time In: ${timeIn} and Time Out: ${timeOut}`
          }
          const adminActivity = {
            adminId: this.$store.state.auth.user.uid,
            activityOnUser: this.selectedEmployee,
            action: "Added",
            activityOnUserName: selectedEmployeeObj.username || 'Unknown User',
            activityByUserName: this.$store.state.auth.user.username || 'Unknown User',
            activityTitle: 'hours manually added',
            activityDescription: commonFields.description,
            activityName: commonFields.activityName,
            type: 'manual_hours',
            timestamp: new Date().toLocaleString('en-PK'),
            timeInChange: timeIn,
            timeOutChange: timeOut,
            reason: this.reason
          };

          const activityData = await logAdminActivity(adminActivity);
          const { username, uid } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "manual_hours",
              activityDescription: commonFields.description,
              activityName: commonFields.activityName,
              activityOnUser: selectedEmployeeObj.uid,
              activityOnUserName: selectedEmployeeObj.username,
              activityByUserName: username,
              action: "added",
            },
            this.$store.state.auth,
            uid
          );

          await firebaseDB.pushDatabase("timePeriod/", obj);
          swal("Success", "Log added successfully.", "success");

          this.isEditModalOpen = false;
          await this.selectMonthYear();
          return;

        } catch (err) {
          console.log("Error details:", err);
          swal("Error", "Failed to add new log: " + err.message, "error");
          return;
        } finally {
          this.loading.editRequest = false;
        }
      }



    if (!timeIn || !timeOut) {
      swal("Missing Fields", "Both Time In and Time Out must be filled.", "warning");
      return;
    }

    try {
      this.loading.editRequest = true
      const originalDate = moment(log.createdAt);

      const [inHours, inMinutes] = moment(timeIn, "hh:mm A").format("HH:mm").split(":");
      const [outHours, outMinutes] = moment(timeOut, "hh:mm A").format("HH:mm").split(":");


      let updatedTimeIn = originalDate.clone().hours(inHours).minutes(inMinutes).seconds(0).milliseconds(0).valueOf();
      let updatedTimeOut = originalDate.clone().hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
      const isNightShift = (selectedEmployeeObj && selectedEmployeeObj.shift && selectedEmployeeObj.shift.toLowerCase() === "night") || null

      if (isNightShift) {
        const timeInHour = moment(updatedTimeIn).hours();
        const timeOutHour = moment(updatedTimeOut).hours();

        if (timeInHour < 12 && timeOutHour >= 12) {
          swal("Invalid Timing", "12 PM is the cutoff time for night shifts. Please select a valid Time Out.", "error");
          return;
        }
      }

      if (isNightShift && updatedTimeOut < updatedTimeIn) {
        updatedTimeOut = originalDate.clone().add(1, 'day').hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
      }

      const updatedSessions = [...log.sessions];
      
      const isTimeInChanged = log.timeIn !== timeIn;
      const isTimeOutChanged = log.timeOut !== timeOut;

      if (isTimeInChanged) {
        if (updatedSessions.length > 0 && updatedTimeIn >= updatedSessions[0].timeOut) {
          const formattedTimeOut = moment(updatedSessions[0].timeOut).format("hh:mm A");
          swal("Invalid Time In", `Time In must be earlier than ${formattedTimeOut}`, "error");
          return;
        }
      }

      if (isTimeOutChanged) {
        const lastSession = updatedSessions[updatedSessions.length - 1];
        if (lastSession && updatedTimeOut <= lastSession.timeIn) {
          const formattedTimeIn = moment(lastSession.timeIn).format("hh:mm A");
          swal("Invalid Time Out", `Time Out must be later than ${formattedTimeIn}`, "error");
          return;
        }
      }

      if (log.timeIn !== timeIn && updatedSessions[0]) {
        updatedSessions[0].timeIn = updatedTimeIn;
      }
      if (log.timeOut !== timeOut && updatedSessions[updatedSessions.length - 1]) {
        updatedSessions[updatedSessions.length - 1].timeOut = updatedTimeOut;
      }

      if (log.timeIn === timeIn && log.timeOut === timeOut) {
        swal("No Changes", "There are no changes to be saved.", "info");
        return;
      }

      let updatedLatestScreenshotTime = log.latestScreenshotTime;
      if (log.timeOut !== timeOut) {
        updatedLatestScreenshotTime = updatedTimeOut;
      }
      const user = this.employees.find(emp => emp.uid === log.userId);
      const userName = user ? user.username : 'Unknown User';
      const userEmail = user ? user.email : 'Unknown User';
      let timeParts = [];
      let timeInChange = null;
      let timeOutChange = null;
      if (log.timeIn !== timeIn) {
        timeInChange = `${!log.timeIn ? "N/A" : log.timeIn} → ${timeIn}`;
        timeParts.push(`Time In: ${timeInChange}`);
      }
      if (log.timeOut !== timeOut) {
        timeOutChange = `${!log.timeOut ? "N/A" : log.timeOut} → ${timeOut}`;
        timeParts.push(`Time Out: ${timeOutChange}`);
      }
      const timeText = timeParts.join(' and ');

      const currentUser = this.$store.state.auth.user;
      const isValid = this.hasAdminAccess && !(log.userId === currentUser.uid && currentUser.isSuperAdmin !== true);
      if (isValid) {
        const payload = {
          timeIn: updatedTimeIn,
          timeOut: updatedTimeOut,
          sessions: updatedSessions,
          latestScreenshotTime: updatedLatestScreenshotTime,
          editRequest: null,
          late: await this.calculateLate(updatedTimeIn)
        };
        const commonFields = {
          description: `${this.$store.state.auth.user.email} updated ${userEmail}'s hours for ${this.currentMonth} ${log.day}, ${this.currentYear}. ${timeText}`,
          activityName: `${this.$store.state.auth.user.username} updated ${userName}'s hours for ${this.currentMonth} ${log.day}, ${this.currentYear}. ${timeText}`,
        }
        const adminActivity = {
          adminId: this.$store.state.auth.user.uid,
          activityOnUser: log.userId,
          activityOnUserName: log.name,
          activityByUserName: this.$store.state.auth.user.username || 'Unknown User',
          activityTitle: 'hours manually updated',
          activityDescription: commonFields.description,
          activityName: commonFields.activityName,
          type: 'manual_hours',
          action:"Updated",
          timestamp: new Date().toLocaleString('en-PK'),
          timeInChange,
          timeOutChange,
          Key: log.key,
          reason: this.reason 
        };
        const activityData = await logAdminActivity(adminActivity);

        const { username, uid } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "manual_hours",
            activityDescription: commonFields.description,
            activityName: commonFields.activityName,
            activityOnUser: log.userId,
            activityOnUserName: log.name,
            activityByUserName: username,
            action: "updated",
          },
          this.$store.state.auth,
          uid
        );
   

        await firebaseDB.updateLogTime(log.key, payload);
        swal("Success", "Log updated successfully.", "success");
        this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, log.userId);
      } else {
        const userName = this.$store.state.auth.user.username || 'Unknown User';
        const userEmail = this.$store.state.auth.user.email || 'Unknown User';
        const role = this.$store.state.auth.user.role;
        const isSuperAdmin = this.$store.state.auth.user.isSuperAdmin || null
        const editRequest = {
          userName,
          userEmail,
          day:log.day,
          timeIn,
          timeOut,
          originalTimeIn: log.timeIn!== undefined ? log.timeIn : "",
          originalTimeOut: log.timeOut !==undefined ? log.timeOut : "",
          requestedAt: new Date().getTime(),
          userId:log.userId,
          role,
          isSuperAdmin,
          Key: log.key,
          reason: this.reason,
        };
        const commonFields = {
          description: `${userEmail} requested an edit for ${this.currentMonth} ${log.day}, ${this.currentYear}. ${timeText}`,
          activityName: `${userName} requested an edit for ${this.currentMonth} ${log.day}, ${this.currentYear}. ${timeText}`,
        }
        const adminActivity = {
          activityOnUser: log.userId,
          activityOnUserName: log.name,
          activityByUserName: log.name,
          action:"Requested",
          activityTitle: 'hours edit request',
          activityDescription: commonFields.description,
          activityName: commonFields.activityName,
          type: 'manual_hours',
          timestamp: new Date().toLocaleString('en-PK'),
          timeInChange,
          timeOutChange,
          Key: log.key,
          reason: this.reason
        };
        const activityData = await logAdminActivity(adminActivity);

        await handleActivityNotification(
          {
            type: "manual_hours",
            activityDescription: commonFields.description,
            activityName: commonFields.activityName,
            activityOnUser: log.userId,
            activityOnUserName: log.name,
            activityByUserName: userName,
            action: "request"
          },
          this.$store.state.auth,
          log.userId
        );

        if (!activityData.latitude || !activityData.longitude) {
          swal("Error", "Geolocation is required to submit an edit request.", "error");
          return;
        }
        await firebaseDB.updateLogTime(log.key, { editRequest });
        swal("Success", "Edit request submitted for admin approval.", "success");
      }

      this.isEditModalOpen = false;
      if (logIndex >= 0) {
        this.$set(this.expandedPanels, logIndex, true);
      }
      this.selectMonthYear();

    } catch (err) {
      if (err.message.includes("Location permission")) {
        swal("Error", err.message, "error");
      } else {
        console.log("Error details:", err);
        swal("Error", "Failed to add new log: " + err.message, "error");
      }
      return;
    } finally {
      this.loading.editRequest = false
    }
    },
    openEditRequestModal(log) {
      this.selectedEditRequest = {
        key: log.key,
        originalTimeIn: log.timeIn,
        originalTimeOut: log.timeOut,
        editRequest: log.editRequest
      };
      this.isEditRequestModalOpen = true;
    },
    async approveEditRequest() {
      const { allowed, message } = this.canPerformRequestAction(
        this.selectedEditRequest.editRequest,
        this.$store.state.auth.user,
        "approve"
      );

      if (!allowed) {
        swal("Error", message, "error");
        return;
      }
      if (!this.selectedEditRequest || !this.selectedEditRequest.key) {
        swal("Error", "No edit request selected.", "error");
        return;
      }

      try {
        const log = this.logs.find(l => l && l.key === this.selectedEditRequest.key);
        if (!log) {
          swal("Error", "Log not found.", "error");
          return;
        }
        const logIndex = this.logs.findIndex(l => l && l.key === this.selectedEditRequest.key);
        const originalDate = moment(log.createdAt);
        const timeIn = this.selectedEditRequest.editRequest.timeIn;
        const timeOut = this.selectedEditRequest.editRequest.timeOut;

        const [inHours, inMinutes] = moment(timeIn, "hh:mm A").format("HH:mm").split(":");
        const [outHours, outMinutes] = moment(timeOut, "hh:mm A").format("HH:mm").split(":");
        const updatedTimeIn = originalDate.clone().hours(inHours).minutes(inMinutes).seconds(0).milliseconds(0).valueOf();
        const updatedTimeOut = originalDate.clone().hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
        const updatedSessions = [...log.sessions];

        if (log.timeIn !== timeIn && updatedSessions[0]) {
          updatedSessions[0].timeIn = updatedTimeIn;
        }
        if (log.timeOut !== timeOut && updatedSessions[updatedSessions.length - 1]) {
          updatedSessions[updatedSessions.length - 1].timeOut = updatedTimeOut;
        }

        const user = this.employees.find(emp => emp.uid === log.userId);
        const username = user ? user.username : 'Unknown User';
        const userEmail = user ? user.email : 'Unknown Email';

        let timeChanges = [];
        let timeInChange = null;
        let timeOutChange = null;

        if (log.timeIn !== timeIn) {
          timeInChange = `${!log.timeIn ? "N/A" : log.timeIn} → ${timeIn}`;
          timeChanges.push(`Time In: ${timeInChange}`);
        }
        if (log.timeOut !== timeOut) {
          timeOutChange = `${!log.timeOut ? "N/A" : log.timeOut} → ${timeOut}`;
          timeChanges.push(`Time Out: ${timeOutChange}`);
        }
        const timeChangesText = timeChanges.join(' and ');
        const activityName = `${this.$store.state.auth.user.username} approved ${username}'s request to edit working hours for ${this.currentMonth} ${log.day}, ${this.currentYear}${timeChangesText ? `. ${timeChangesText}` : ''}`;
        const activityDescription = `${this.$store.state.auth.user.email} approved ${userEmail}'s request to edit working hours for ${this.currentMonth} ${log.day}, ${this.currentYear}${timeChangesText ? `. ${timeChangesText}` : ''}`;

        const adminActivity = {
          adminId: this.$store.state.auth.user.uid,
          activityOnUser: log.userId,
          activityOnUserName: log.name,
          action:"Approved",
          activityByUserName: this.$store.state.auth.user.username || 'Unknown User',
          activityTitle: 'hours manually updated',
          activityName,
          activityDescription,
          type: 'manual_hours',
          timestamp: new Date().toLocaleString('en-PK'),
          timeInChange,
          timeOutChange,
          Key: log.key
        };
        const activityData = await logAdminActivity(adminActivity);

        const { username: adminUserName, uid } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "manual_hours",
            activityDescription: activityDescription,
            activityName,
            activityOnUser: log.userId,
            activityOnUserName: log.name,
            activityByUserName: adminUserName,
            action: "approve",
          },
          this.$store.state.auth,
          uid
        );

        if (!activityData.latitude || !activityData.longitude) {
       swal("Error", "Location permission is denied. Please enable it in browser settings.",  "error");;
          return;
        }
        const payload = {
          timeIn: updatedTimeIn,
          timeOut: updatedTimeOut,
          latestScreenshotTime: updatedTimeOut,
          sessions: updatedSessions,
          editRequest: null,
        late:await this.calculateLate(updatedTimeIn),
        };
        await firebaseDB.updateLogTime(this.selectedEditRequest.key, payload);
        swal("Success", "Edit request approved.", "success");
        this.isEditRequestModalOpen = false;
        this.selectedEditRequest = null;
        if (logIndex >= 0) {
          this.$set(this.expandedPanels, logIndex, true);
        }
      this.manualHoursActivities =  await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear);
        this.selectMonthYear();
      } catch (err) {
        if (err.message.includes("Location permission")) {
          swal("Error", err.message, "error");
        } else {
          swal("Error", "Failed to add new log: " + err.message, "error");
        }
        return;
      }
    },
    async rejectEditRequest() {
      const { allowed, message } = this.canPerformRequestAction(
        this.selectedEditRequest.editRequest,
        this.$store.state.auth.user,
        "reject"
      );

      if (!allowed) {
        swal("Error", message, "error");
        return;
      }
      if (!this.selectedEditRequest || !this.selectedEditRequest.key) {
        swal("Error", "No edit request selected.", "error");
        return;
      }
      try {
        const edit = this.selectedEditRequest.editRequest;
        const username = this.$store.state.auth.user.username;
        const useremail = this.$store.state.auth.user.email;
        const timeInChanged = edit.originalTimeIn !== edit.timeIn;
        const timeOutChanged = edit.originalTimeOut !== edit.timeOut;
        let timeChanges = [];
        let timeInChange = null;
        let timeOutChange = null;
        if (timeInChanged) {
          timeInChange = `${!edit.originalTimeIn ? "N/A" : edit.originalTimeIn} → ${edit.timeIn}`;
          timeChanges.push(`Time In: ${timeInChange}`);
        }
        if (timeOutChanged) {
        timeOutChange = `${!edit.originalTimeOut ? "N/A" :edit.originalTimeOut} → ${edit.timeOut}`;
          timeChanges.push(`Time Out: ${timeOutChange}`);
        }
        const timeChangeText = timeChanges.length > 0 ? `. ${timeChanges.join(' and ')}` : '';
        const loggedInUser = this.$store.state.auth.user;
        const isAdmin = loggedInUser.role === 'admin';

        const activityDescription = `${useremail} rejected ${edit.userEmail}'s request to edit working hours for ${this.currentMonth} ${edit.day}, ${this.currentYear}${timeChangeText}`;
        const activityName = `${username} rejected ${edit.userName}'s request to edit working hours for ${this.currentMonth} ${edit.day}, ${this.currentYear}${timeChangeText}`;

        let adminActivity = {
          timestamp: new Date().toLocaleString('en-PK'),
          activityDescription,
          activityName,
          activityByUserName: username || 'Unknown User',
          action: "Rejected",
          Key: this.selectedEditRequest.key,
          activityOnUser: edit.userId,
          activityOnUserName: edit.userName || 'Unknown User',
          activityTitle: 'hours edit request',
          type: 'manual_hours',
          timeInChange,
          timeOutChange
        };
        if (isAdmin) {
          adminActivity.adminId = loggedInUser.uid;
        }
        const activityData = await logAdminActivity(adminActivity);

        await handleActivityNotification(
          {
            type: "manual_hours",
            activityDescription: activityDescription,
            activityName,
            activityOnUser: edit.userId,
            activityOnUserName: edit.userName,
            activityByUserName: username,
            action: "reject",
          },
          this.$store.state.auth,
          this.$store.state.auth.user.uid
        );

        if (!activityData.latitude || !activityData.longitude) {
          swal("Error", "Geolocation is required to reject the edit request.", "error");
          return;
        }
        await firebaseDB.updateLogTime(this.selectedEditRequest.key, { editRequest: null });
    
        swal("Success", "Edit request rejected.", "success");
        this.isEditRequestModalOpen = false;
        this.selectedEditRequest = null;
        this.selectMonthYear();
      } catch (err) {
        if (err.message.includes("Location permission")) {
          swal("Error", err.message, "error");
        } else {
          swal("Error", "Failed to add new log: " + err.message, "error");
        }
        return;
      }
    },
    details(index) {
      this.currentObj = this.logs[index];
      this.previewDetails = true;
      this.currentImgObj = null;
      this.currentScreenshotIndex = 0;
    },
    calculateMonthlyStats() {
      const totalLates = this.logs.filter(
        (log) => log && log.late && (log.late.hours > 0 || log.late.minutes > 0)
      ).length;

      let totalSpentHours = 0;
      let totalSpentMinutes = 0;
      this.logs.forEach((log) => {
        if (log && log.completed) {
          totalSpentHours += log.completed.hours || 0;
          totalSpentMinutes += log.completed.minutes || 0;
        }
      });
      totalSpentHours += Math.floor(totalSpentMinutes / 60);
      totalSpentMinutes %= 60;

      const monthIndex = new Date(`${this.currentMonth} 1, ${this.currentYear}`).getMonth();
      const daysInMonth = new Date(this.currentYear, monthIndex + 1, 0).getDate();
      let workingDaysInMonth = 0;

      for (let date = 1; date <= daysInMonth; date++) {
        const currentDate = new Date(this.currentYear, monthIndex, date);
        if (
          this.workingDays.includes(
            currentDate.toLocaleDateString("en-US", { weekday: "long" })
          )
        ) {
          workingDaysInMonth++;
        }
      }

      const totalRequiredHours = workingDaysInMonth * Number(this.workingHours);

      const daysWithLogs = this.logs.filter((log) => log).length;
      let averageHours = 0;
      let averageMinutes = 0;
      if (daysWithLogs > 0) {
        const totalHoursDecimal = totalSpentHours + totalSpentMinutes / 60;
        const averageHoursDecimal = totalHoursDecimal / daysWithLogs;
        averageHours = Math.floor(averageHoursDecimal);
        averageMinutes = Math.round((averageHoursDecimal - averageHours) * 60);
      }

      const netBalanceHours = totalSpentHours + totalSpentMinutes / 60 - totalRequiredHours;
      const netBalanceFormatted = netBalanceHours.toFixed(1);
      const isNegative = netBalanceHours < 0;

      return {
        totalLates,
        totalSpentHours,
        totalSpentMinutes,
        totalRequiredHours,
        averageHours,
        averageMinutes,
        netBalanceHours,
        netBalanceFormatted,
        isNegative,
        workingDaysInMonth
      };
    },
    
    exportPDF() {
      const stats = this.calculateMonthlyStats();
      const body = [["Date", "Day", "Time In", "Time Out", "Hours", "Late"]];
      const logs = this.logs;
      const days = this.days;
      const cMonth = this.currentMonth;
      const cYear = this.currentYear;
      var name = "";
      logs.map(function (item, i) {
        if (item) {
          const late =
            item.late.hours !== 0
              ? item.late.hours + " hours " + item.late.minutes + " minutes"
              : item.late.minutes !== 0
                ? item.late.minutes + " minutes"
                : "Not Late";
          const hoursSpent = item.completed ? item.completed.hours + "h " + item.completed.minutes + "m" : "0h 0m";

          const timeIn = item.editRequest ? `${item.timeIn} (${item.editRequest.timeIn} pending)` : item.timeIn;
          const timeOut = item.editRequest ? `${item.timeOut} (${item.editRequest.timeOut} pending)` : item.timeOut;

          const arr = [
            item.day + "/" + cMonth + "/" + cYear || "",
            days[i] || "",
            timeIn || "",
            timeOut || "",
            hoursSpent || "",
            late || ""
          ];
          body.push(arr);
          name = item.name || "Report";
        }
      });
      const summaryTable = {
        table: {
          headerRows: 1,
          widths: ["*", "*"],
          body: [
            [{ text: "Monthly Summary", style: "tableHeader", colSpan: 2, alignment: "center" }, {}],
            ["Total Lates", stats.totalLates.toString()],
            ["Average Hours Spent", stats.averageHours + " hrs " + stats.averageMinutes + " mins"],
            ["Total Hours Required", stats.totalRequiredHours + " hrs"],
            ["Total Spent Hours", stats.totalSpentHours + (stats.totalSpentMinutes > 0 ? ":" + stats.totalSpentMinutes : "") + " hrs"],
            ["Net Balance", stats.netBalanceFormatted + " hrs"],
          ],
        },
        margin: [0, 0, 0, 20],
      };
      const logsTable = {
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "auto", "auto", "auto", "*"],
          body: body,
        },
      };

      const dd = {
        content: [
          { text: name || "Monthly Report", style: "header" },
          { text: this.currentMonth + " " + this.currentYear, style: "subheader" },
          summaryTable,
          { text: "Daily Logs", style: "subheader" },
          logsTable,
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };

      pdfMake.createPdf(dd).download((name || "Report") + "_" + this.currentMonth + "_" + this.currentYear + ".pdf");
    },
    async init(user) {
      const year = [];
      for (let i = -  5; i < 2; i++) {
        year.push({ name: new Date().getFullYear() + i });
      }
      this.years = year;
      let employees = async allUsers => {
        this.employees = allUsers;
        this.isAdmin = true;
        this.isSuperAdmin = true;
        this.hasAdminAccess = this.isAdmin || this.isSuperAdmin
        this.selectedEmployee = this.employees.filter(emp => emp.isActive)[0].uid || null;
        await this.getLogs(this.selectedEmployee);
        this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, this.selectedEmployee);
      };
      if (user.role == "admin" || user.isSuperAdmin) {
        const allUsers = this.$store.state.auth.allUsers
        const company = this.$store.state.auth.company

        const companyUserIds = company.users.map(user => user.uid);
        const filteredUsers = allUsers.filter(
          user => companyUserIds.includes(user.uid)
        );
        if (filteredUsers) {
          await employees(filteredUsers);
        } else {
          this.$store.watch(this.$store.getters.allUsers, async allUsers => {
            await employees(allUsers);
          });
        }
      } else {
        this.getLogs(user.uid);
        this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, user.uid);
      }
    },
    async selectEmployee() {
      this.isSelectLoading = true;
      await this.getLogs(this.selectedEmployee, this.currentMonth, this.currentYear);
      this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, this.selectedEmployee);
      this.isSelectLoading = false;
    },
    async selectMonthYear(selectedItem) {
      if (selectedItem) {
        if (this.months.some(month => month.name === selectedItem.name)) {
          this.currentMonth = selectedItem.name;
        } else if (this.years.some(year => year.name === selectedItem.name)) {
          this.currentYear = selectedItem.name;
        }
      }
      this.isSelectLoading = true;
      let user = this.$store.state.auth.user;
      if (user.role == "admin" || user.isSuperAdmin) {
        if (this.$store.state.auth.allUsers) {
          await this.getLogs(
            this.selectedEmployee,
            this.currentMonth,
            this.currentYear
          );
          this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, this.selectedEmployee);
        }
      } else {
        await this.getLogs(user.uid, this.currentMonth, this.currentYear);
        this.manualHoursActivities = await firebaseDB.fetchManualHoursActivities(this.currentMonth, this.currentYear, user.uid);
      }
      this.isSelectLoading = false;
    },
    getMonthNum(month) {
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const index = months.indexOf(month);
      if (index !== -1) {
        return index + 1;
      }
      return -1;
    },
    async getLogs(userId, selectMonth, selectYear) {
      await this.getSettingData();
      let date = new Date();
      let store = this.$store;
      const Break = this.breakSecondsIntoHMS;
      let daysName = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
      let workingDays = this.workingDays;
      let workingHours = this.workingHours;
      this.currentMonth = selectMonth || this.months[date.getMonth()].name;
      this.currentYear = selectYear || date.getFullYear();

      let selectMonthNum = this.getMonthNum(this.currentMonth) - 1;
      if (selectMonthNum === -1) {
        console.error("Invalid month selected:", this.currentMonth);
        store.commit("loadingEnds");
        return;
      }
      let days = new Date(
        this.currentYear || date.getFullYear(),
        (selectMonthNum !== -1 ? selectMonthNum : date.getMonth()) + 1,
        0
      ).getDate();
      //loading days
      var totalDays = [];
      for (var i = 1; i <= days; i++) {
        let day =
          daysName[
            new Date(
              this.currentYear || date.getFullYear(),
              selectMonthNum !== -1
                ? selectMonthNum
                : date.getMonth(),
              i
            ).getDay()
          ];

        let isWorkingDay = workingDays.filter(workDay => {
          if (workDay.indexOf(day) !== -1) {
            return workDay;
          }
        });
        if (isWorkingDay.length) {
          totalDays.push(day);
        } else {
          totalDays.push(day + "*");
        }
      }
      let startTime = new Date(
        this.currentYear || date.getFullYear(),
        selectMonthNum !== -1 ? selectMonthNum : date.getMonth(),
        1,
        0,
        0,
        0
      ).getTime();
      let endTime = new Date(
        this.currentYear || date.getFullYear(),
        selectMonthNum + 1 || date.getMonth() + 1,
        0,
        23,
        59,
        59
      ).getTime();
      var database = firebase.database();
      var ref = database.ref("timePeriod");
      ref
        .orderByChild("timeIn")
        .startAt(startTime)
        .endAt(endTime)
        .once("value")
        .then(snapshot => {
          let value = snapshot.val();
          let fullLogs = [];
          const dbTimePeriod = [];
          if (value) {
            let keys = Object.keys(value);
            var logs = _.compact(
              keys.map((val, index) => {
                if (value[val].userId == userId) {
                  const selectedEmp = this.employees.find(emp => emp.uid === userId);
                  const baseShift = (this.isAdmin && selectedEmp ? selectedEmp.shift : this.$store.state.auth.user.shift) || "Morning";
                  let logDay;
                  if (baseShift.toLowerCase() === "night") {
                    logDay = new Date(value[val].createdAt || value[val].timeIn).getDate();
                  } else {
                    logDay = new Date(value[val].timeIn).getDate();
                  }
                  dbTimePeriod.push(value[val])
                  value[val].key = val;
                  value[val]["day"] = logDay;
                  var latein = new Date(value[val].timeIn);
                  var setTime = latein.toString();
                  var middle = setTime.slice(16, 18);
                  var centre = parseInt(middle) + 9;

                  // Calculate total duration from sessions
                  let totalDurationMs = 0;
                  if (value[val].sessions && Array.isArray(value[val].sessions)) {
                    totalDurationMs = value[val].sessions.reduce((total, session, index) => {
                      if (session.timeIn && Number.isFinite(session.timeIn)) {
                        const sessionTimeOut = session.timeOut ||
                          (index === value[val].sessions.length - 1 ?
                            (value[val].latestScreenshotTime || session.timeOut) :
                            session.timeOut);
                        if (sessionTimeOut && Number.isFinite(sessionTimeOut)) {
                          if (sessionTimeOut < session.timeIn) {
                            return total;
                          }
                          return total + (sessionTimeOut - session.timeIn);
                        }
                      }
                      return total;
                    }, 0);
                  }

                  const totalSeconds = Math.floor(totalDurationMs / 1000);
                  const hours = Math.floor(totalSeconds / 3600);
                  const minutes = Math.floor((totalSeconds % 3600) / 60);
                  const seconds = totalSeconds % 60;

                  value[val]["totalDuration"] = {
                    hours,
                    minutes,
                    seconds,
                  };

                  // Add completedPercent logic with validation
                  const totalWorkingSeconds = workingHours * 60 * 60;
                  let completedPercent = 0;
                  if (totalWorkingSeconds > 0 && totalSeconds > 0) {
                    completedPercent = Math.min(Math.round((totalSeconds / totalWorkingSeconds) * 100), 100);
                  } else if (value[val].totalToday && value[val].totalToday > 0) {
                    completedPercent = Math.min(Math.round((value[val].totalToday / 32400) * 100), 100);
                  }
                  // Ensure reactivity for completedPercent
                  Vue.set(value[val], 'completedPercent', Number.isFinite(completedPercent) ? completedPercent : 0);
                

                  value[val].timeIn = moment(value[val].timeIn).format("hh:mm A");
                  const time_Out = value[val].latestScreenshotTime > (value[val].timeOut || 0)
                    ? value[val].latestScreenshotTime
                    : value[val].timeOut;
                  value[val].timeOut = time_Out && moment(time_Out).format("hh:mm A");

                  // Completed Hours logic if hours and minutes are 0
                  if (hours === 0 && minutes === 0 && seconds === 0) {
                    value[val]["completed"] = {
                      hours: Break(value[val].totalToday || 0).hours || 0,
                      minutes: Break(value[val].totalToday || 0).minutes || 0,
                    };
                  } else {
                    value[val]["completed"] = {
                      hours,
                      minutes,
                    };
                  }

                  const allSessions = value[val].sessions;
                  if (allSessions && allSessions.length > 0) {
                    const lastSession = allSessions[allSessions.length - 1];
                    value[val].userStatus = Object.keys(lastSession || {}).length > 1 ? "User Offline" : "User Online";
                  } else {
                    value[val].userStatus = "User Offline";
                  }
                  return value[val];
                }
              })
            );
            fullLogs = totalDays.map((day, index) => {
              const log = _.findWhere(logs, { day: index + 1 }) || null;
              console.debug(`Index ${index}: log=${log ? JSON.stringify({day: log.day, completedPercent: log.completedPercent}) : 'null'}`);
              return log;
            });
          } else {
            fullLogs = totalDays.map(() => null);
            console.debug("No snapshot data, all logs set to null");
          }
          console.log('dbTimePeriod', dbTimePeriod)
          console.log('fullLogs', fullLogs)
          Vue.set(this, 'days', totalDays);
          Vue.set(this, 'logs', fullLogs);
          if (this.expandedPanels.length !== totalDays.length) {
            this.$set(this, 'expandedPanels', new Array(totalDays.length).fill(false));
          }

          store.commit("loadingEnds");
        })
        .catch(error => {
          console.error("Firebase error:", error);
          const fullLogs = totalDays.map(() => null);
          Vue.set(this, 'days', totalDays);
          Vue.set(this, 'logs', fullLogs);
       if (this.expandedPanels.length !== totalDays.length) {
            this.$set(this, 'expandedPanels', new Array(totalDays.length).fill(false));
          }

  
        });
    },
    diff_years: function(dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60 * 24;
      return Math.abs(Math.round(diff / 365.25));
    },
    breakSecondsIntoHMS: function(s) {
      const hours = Math.floor(s / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      const seconds = Math.floor((s % 3600) % 60);

      return { hours, minutes, seconds };
    },
    previewImage(index) { 
      var dialogElement = document.getElementById("preview-dialog");

      if (dialogElement) {
        dialogElement.scrollTop = 0;
      }
      this.currentScreenshotIndex = index;
      this.currentImgObj = this.currentObj.screenshots[index];
    },
    checkLateScreenshot(log) {
      if (!log || !log.timeIn) {
        return false;
      }
      if(!log.screenshots || !log.screenshots.length ) {
        const currentDate = new Date();
        const dateStr = currentDate.toISOString().split("T")[0];
        const timeInStr = `${dateStr} ${log.timeIn}`;
        const timeInMs = new Date(timeInStr).getTime();
        const diffMinutes = (currentDate.getTime() - timeInMs) / (1000 * 60);
        return diffMinutes > 22;
      }

      const firstShotMs = Number(log.screenshots[0].timestamp);
      if (isNaN(firstShotMs)) return false;
      const shotDate = new Date(firstShotMs);
      const dateStr = shotDate.toISOString().split("T")[0];
      const timeInStr = `${dateStr} ${log.timeIn}`;
      const timeInMs = new Date(timeInStr).getTime();
      if (isNaN(timeInMs)) {
        console.warn("Could not parse timeIn:", timeInStr);
        return false;
      }
      const diffMinutes = (firstShotMs - timeInMs) / (1000 * 60);
      return diffMinutes > 22;
    },

    shouldHighlight(log) {
      let highlight = true; 
      let isExpertizo = true;

      if (
        !log ||
        !log.coordinates ||
        !log.coordinates.timeIn ||
        !log.coordinates.timeIn.latitude ||
        !log.coordinates.timeIn.longitude
      ) {
        return { highlight: false, isExpertizo: false };
      }
      const { latitude, longitude } = log.coordinates.timeIn;
      isExpertizo = !isExpertizoLocation(latitude, longitude);
      return { highlight, isExpertizo };
    },

    openMapPopup(payload) {
      if (typeof payload === "number") {
        this.selectedUser = this.logs[payload];
        this.currentCoordinates = this.logs[payload].coordinates || {};
      }

      if (typeof payload === "object") {
        this.selectedUser = payload;
        this.currentCoordinates = payload;
      }

      this.mapPopup = true;
      this.$nextTick(() => {
        const selectedUser = this.selectedUser;
        if (
          selectedUser.coordinates &&
          selectedUser.coordinates.timeIn &&
          document.getElementById("mapIn")
        ) {
          const { latitude, longitude } = selectedUser.coordinates.timeIn;
          const mapIn = L.map("mapIn").setView([latitude, longitude], 15);
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(mapIn);
          L.marker([latitude, longitude])
            .addTo(mapIn)
            .bindPopup("First Time In Location")
            .openPopup();
        }

        // For timeOut
        if (
          selectedUser.coordinates &&
          selectedUser.coordinates.timeOut &&
          document.getElementById("mapOut")
        ) {
          const { latitude, longitude } = selectedUser.coordinates.timeOut;
          const mapOut = L.map("mapOut").setView([latitude, longitude], 15);
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(mapOut);
          L.marker([latitude, longitude])
            .addTo(mapOut)
            .bindPopup("Last Time Out Location")
            .openPopup();
        }
        if (
          selectedUser.latitude &&
          selectedUser.longitude &&
          document.getElementById("mapActivity")
        ) {
          const map = L.map("mapActivity").setView(
            [selectedUser.latitude, selectedUser.longitude],
            15
          );
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(map);
          L.marker([selectedUser.latitude, selectedUser.longitude])
            .addTo(map)
            .bindPopup("Activity Location")
            .openPopup();
        }
      });
    },
    userOnline(logsIndex){
      const createdAt = new Date(parseInt(logsIndex.createdAt));
      const currentDate = new Date();
      if(logsIndex.userStatus === 'User Online' && createdAt.toDateString() === currentDate.toDateString()){
        return true
      }
      return false
    },
     checkTimeoutResult(index, userOnline) {
      if (userOnline) return false;
      const result = this.checkTimeout(this.logs[index]);
      return result;

    },
    checkTimeout(logsIndex) {
      if (!logsIndex) return false;

      const { latestScreenshotTime, timeOut } = logsIndex;
      if (!latestScreenshotTime && !timeOut) return false;

      try {
        if (!timeOut && latestScreenshotTime) {
          const getLatestScreenshotTime = new Date(parseInt(latestScreenshotTime));
          const latestScreenshotFormatted = getLatestScreenshotTime.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
          });
          return latestScreenshotFormatted;
        }

        const [hours = "0", minutesMeridiem = "0 AM"] = (timeOut || "0:0 AM").split(':');
        const [minutes = "0", meridiem = "AM"] = minutesMeridiem.split(' ');

        const calcTimeout = new Date().setHours(
          parseInt(hours) + (meridiem === 'PM' && parseInt(hours) < 12 ? 12 : 0),
          parseInt(minutes),
          0
        );

        const calcTimeoutFormatted = new Date(calcTimeout).toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });

        if (!latestScreenshotTime) return calcTimeoutFormatted;

        const getLatestScreenshotTime = new Date(parseInt(latestScreenshotTime));
        const latestScreenshotFormatted = getLatestScreenshotTime.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });

        if (getLatestScreenshotTime.getTime() > new Date(calcTimeout).getTime()) {
          return latestScreenshotFormatted;
        } else {
          return calcTimeoutFormatted;
        }

      } catch (err) {
        console.error("Error checking timeout:", err);
        return false;
      }
    },
    openHistoryModal(activity) {
      console.log('Opening history modal with activity:', activity);
      this.manualHoursActivity = activity || [];
      this.isHistoryModalOpen = true;
    },
    closeHistoryModal() {
      this.isHistoryModalOpen = false;
    }
  },
  computed: {
    async getAllHolidays() {
        const holidays = await firebaseDB.getAllHolidays()
        this.holidays = holidays;
    },
    loading() {
      return this.$store.state.loading;
    },
    averageHours() {
      const stats = this.calculateMonthlyStats();
      return stats.averageHours;
    },
    averageMinutes() {
      const stats = this.calculateMonthlyStats();
      return stats.averageMinutes;
    },
    pendingEditRequestCount() {
    return this.logs.filter(log => log && log.editRequest).length;
  }
  }
};
</script>

<style scoped>
.v-expansion-panel,
.v-expansion-panel-content,
.v-card {
  overflow: visible !important;
  pointer-events: auto !important;
  position: relative !important;
}
.custom-tooltip-wrapper:hover .custom-tooltip {
  visibility: visible !important;
}
.custom-tooltip {
  visibility: hidden;
  position: absolute;
  bottom: 20px;
  right: -130px;
  transform: translateX(-50%);
  background: #000000;
  color: #ffffff;
  padding: 5px 8px;
  border-radius: 4px;
  max-width: 300px;
  text-align: center;
   z-index: 10000;
  min-width: 200px;
  font-size: 13px;
}
.next-previous-btn{
  width: 130px;
  padding:5px;
  height:42px;
  font-weight: 500;
  text-transform: none;
  border-radius: 6px;
  box-shadow: none;
  background-color: #435851 !important;
  color: #ffffff;
  font-size: 14px;
}
.action-buttons{
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: space-between;

}
/* Mobile adjustments */
@media (max-width: 650px) {
  .next-previous-btn {
    width: 120px;
    padding:5px;
    height:32px;
    overflow: hidden;
    font-size: 12px;
  }
  .action-buttons {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;  
  }

  .btn-text {
    display: none;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports.vue